module.exports = __webpack_public_path__ + "img/icon-frig-1.27766fb8.svg";